





















import { WhtAmountType } from "@/enums/enums";
import { DoGetPaymentWhtOption } from "@/helper/paymentHelper";
import { GetWhtAmountValue, NewObject } from "@/helper/shareHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreTransaction = namespace("Transaction");

@Component
export default class DropdownPaymentWht extends Vue {
  @Prop({}) readonly whtPayment!: any;
  @Prop({}) readonly paymentGroup!: any;
  @Prop({}) readonly disabled!: boolean;
  @Prop({}) readonly transactionCreate!: any;

  private options = DoGetPaymentWhtOption();
  private selectedWht: any = {
    name: "3%",
    value: GetWhtAmountValue(WhtAmountType.ThreePercent),
    type: WhtAmountType.ThreePercent,
  };
  private selectedWhtPayment: any = {};

  @StoreTransaction.Mutation
  private MutationOnChangeWhtPayment!: (input: any) => void;

  @Watch("whtPayment.whtAmountTypeId", { immediate: true })
  whtAmountTypeIdChanged() {
    const test = this.options.find((x) => x.type === this.whtPayment.whtAmountTypeId);
    if (test) {
      this.selectedWht = { type: test.type };
    } else {
      this.selectedWht = { type: GetWhtAmountValue(WhtAmountType.ThreePercent) };
    }
  }

  public SelectWht(item: any) {
    if (item) {
      this.selectedWht = item;
      this.OnChangeWht(item);
    }
  }

  public OnChangeWht(item: any) {
    this.selectedWhtPayment = this.whtPayment;
    this.selectedWhtPayment.whtAmountTypeId = item.type;
    this.whtPayment.whtAmountTypeId = item.type;
    this.whtPayment.isWht = false;
    this.MutationOnChangeWhtPayment({
      transactionCreate: this.transactionCreate,
      paymentGroup: this.paymentGroup,
      isFromEvent: false,
    });

    this.whtPayment.isWht = true;
    this.MutationOnChangeWhtPayment({
      transactionCreate: this.transactionCreate,
      paymentGroup: this.paymentGroup,
      isFromEvent: false,
    });
  }
}
